export default __webpack_public_path__ + "static/media/FONDO_DIGITALIZA.a094465f.jpg";